/**
 * buildMorphUrl — Constructs the iframe src URL for morph-viewer-v2.html
 * Extracted from PublicShopBrowser.tsx handleMorphViewer so it can be reused
 * by both the browse page and MorphViewerPage.
 */
import { apiUrl } from '@/config'

export interface DatasetWithPaths {
  id: string
  paths?: {
    cameras?: string
    [key: string]: any
  }
}

/**
 * Build the full URL for morph-viewer-v2.html including blob base + SAS token.
 * Falls back to API proxy if SAS fetch fails.
 */
export async function buildMorphUrl(dataset: DatasetWithPaths): Promise<string> {
  const paths = dataset.paths
  const camerasPath =
    paths?.cameras || `/api/scan-data/${dataset.id}/section_0/cameras.json`

  // Strip /api/scan-data/ prefix to get blob-relative path ending with /
  const apiPrefix = '/api/scan-data/'
  const blobRelative = camerasPath.startsWith(apiPrefix)
    ? camerasPath.substring(apiPrefix.length, camerasPath.lastIndexOf('/') + 1)
    : camerasPath.substring(0, camerasPath.lastIndexOf('/') + 1)

  // Try direct blob access with SAS token (much faster)
  try {
    const res = await fetch(apiUrl('/api/scan-data-token'))
    if (res.ok) {
      const { base_url, sas_token } = await res.json()
      const base = `${base_url}/${blobRelative}`
      const params = new URLSearchParams({ base, sas: sas_token })
      return `/morph-viewer/morph-viewer-v2.html?${params.toString()}`
    }
  } catch {
    // fall through to API proxy
  }

  // Fallback: API proxy (slower but always works)
  const base = apiUrl(`${apiPrefix}${blobRelative}`)
  return `/morph-viewer/morph-viewer-v2.html?base=${encodeURIComponent(base)}`
}
